jQuery(function($){
	$('.sc-field-editor').on('click', '.field.audio[field_name="sample_mp3"] .create-dynamic-sample', function(e){
		e.preventDefault();

		const parentDiv = $(this).closest('.field.audio');
		const arrayDiv = parentDiv.closest('.array-field-info');
		const modalBodyDiv = $(this).closest('.scfe-modal-body');
		const mixFieldValue = arrayDiv.find('.field.typeahead[field_name="full_mix_download"] .value input.typeahead-value').val();

		const startTime = modalBodyDiv.find('[name="sc-fields[sample_start_time]"]').val() ? modalBodyDiv.find('[name="sc-fields[sample_start_time]"]').val() : 0;
		const duration = modalBodyDiv.find('[name="sc-fields[sample_duration]"]').val() ? modalBodyDiv.find('[name="sc-fields[sample_duration]"]').val() : 30;

		modalBodyDiv.addClass('creating-sample');
		modalBodyDiv.find('audio').each(function(){
			this.pause();
		});

		if(mixFieldValue) {
			const data = {
				action: 'choralshop_ajax_create_dynamic_sample',
				product_id: mixFieldValue,
				start_time: startTime,
				duration: duration,
			};
			console.log(data);

			$.post('/wp-admin/admin-ajax.php', data, function(response){
				console.log(response);
				const responseJson = JSON.parse(response);
				console.log(responseJson);
	
				modalBodyDiv.removeClass('creating-sample').addClass('sample-created');
				modalBodyDiv.find('[field_name="sample_result_audio"] audio').attr('src', responseJson.new_file_url);
				modalBodyDiv.find('.sample-results-wrapper').attr('sample_src', responseJson.new_file_url);
			});
		} else {
			window.alert('Cannot create a sample unless a full mix is defined.')
			modalBodyDiv.removeClass('creating-sample').removeClass('sample-created');
		}
	});

	$('.sc-field-editor').on('click', '.field.audio[field_name="sample_mp3"] .sample-results-wrapper .confirm-dynamic-sample', function(e){
		const modalBodyDiv = $(this).closest('.scfe-modal-body');
		const sampleResultsDiv = $(this).closest('.sample-results-wrapper');
		const sampleSrc = sampleResultsDiv.attr('sample_src');
		const postId = sampleResultsDiv.attr('post_id');

		//Remove Sample
		modalBodyDiv.removeClass('creating-sample').removeClass('sample-created').addClass('adding-sample-to-song');
		sampleResultsDiv.attr('sample_src', '');

		//Pause Audio
		modalBodyDiv.find('audio').each(function(){
			this.pause();
		});

		const data = {
			action: 'choralshop_ajax_add_dynamic_sample_to_song',
			sample_src: sampleSrc,
			post_id: postId,
		};

		const addingSampleMessageDiv = $('.sample-add-to-song-wrapper');
		const addingSampleMessage = addingSampleMessageDiv.html();

		$.post('/wp-admin/admin-ajax.php', data, function(response){
			console.log(response);
			const responseJson = JSON.parse(response);
			console.log(responseJson);

			addingSampleMessageDiv.html('Sample added!');
			jQuery(document).trigger('scfe-upload-display-update', { attachmentId: responseJson.attachment_id, el: sampleResultsDiv });
			setTimeout(function(){
				addingSampleMessageDiv.html(addingSampleMessage);
				modalBodyDiv.removeClass('adding-sample-to-song');
				modalBodyDiv.closest('.scfe-modal-wrapper').removeClass('showing');
			}, 2000);
		});
	});

	$('.sc-field-editor').on('click', '.field.audio[field_name="sample_mp3"] .sample-results-wrapper .cancel-dynamic-sample', function(e){
		const modalBodyDiv = $(this).closest('.scfe-modal-body');
		const sampleResultsDiv = $(this).closest('.sample-results-wrapper');
		const sampleSrc = sampleResultsDiv.attr('sample_src');
		
		//Remove Sample
		modalBodyDiv.removeClass('creating-sample').removeClass('sample-created');
		sampleResultsDiv.attr('sample_src', '');

		//Pause Audio
		modalBodyDiv.find('audio').each(function(){
			this.pause();
		});

		const data = {
			action: 'choralshop_ajax_remove_dynamic_sample',
			sample_src: sampleSrc,
		};
		$.post('/wp-admin/admin-ajax.php', data, function(response){
			console.log(response);
			const responseJson = JSON.parse(response);
			console.log(responseJson);
		});
	});
});